export default __webpack_public_path__ + "static/media/setting_icon_hover.311eb082.svg";